<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ "Scheduled Movies Order" }}</div>

      <div class="section-wrapper">
        <div class="white-wrapper py-3 mb-2">
          <div class="row">
            <div
              class="col-2 d-flex flex-column justify-content-between align-items-center"
            >
              <div class="row mb-4">
                <h6>
                  Selected Movies
                </h6>
              </div>
              <div class="row">
                <h6>
                  Available Movies
                </h6>
              </div>
            </div>

            <div class="col-10">
              <div class="row mb-4">
                <div class="text-blue font-weight-bold w-100">
                  <draggable
                    :list="selectedMovies"
                    :move="checkMoveOnAvailMovieChange"
                    group="availMovieListGroup"
                    tag="section"
                    @change="onAvailMovieChange"
                  >
                    <span
                      v-for="(movie, groupIndex) in selectedMovies"
                      :key="movie.movie_title + groupIndex + 'selected'"
                      class="p-2 badge badge-primary ml-3 mb-1 move"
                    >
                      {{ movie.movie_title }}
                    </span>
                    <span>&nbsp;</span>
                  </draggable>
                </div>
              </div>

              <div class="row">
                <div class="text-blue font-weight-bold w-100">
                  <draggable
                    :group="{
                      name: 'availMovieListGroup',
                      pull: true,
                      put: true,
                    }"
                    :list="availMovieList"
                    :move="checkMoveOnAvailMovieChange"
                    tag="section"
                    @change="onAvailMovieChange"
                  >
                    <span
                      v-for="(movie, groupIndex) in availMovieList"
                      :key="movie.movie_title + groupIndex + 'availMovieList'"
                      class="p-2 badge badge-secondary ml-3 mb-1 move"
                    >
                      {{ movie.movie_title }}
                    </span>
                    <span>&nbsp;</span>
                  </draggable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import moment from "moment-timezone";
  import DatePicker from "vue2-datepicker";
  import Multiselect from "vue-multiselect";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import draggable from "vuedraggable";
  import VueHtml2pdf from "vue-html2pdf";

  export default {
    components: { VueHtml2pdf, DatePicker, Multiselect, NoRecords, draggable },
    data() {
      return {
        loader: null,
        selectedMovies: [],
        availMovieList: [],
        scheduleMovieRaw: [],
      };
    },
    beforeMount() {
      this.getMovieData();
    },
    methods: {
      moment,
      onAvailMovieChange: function(evt) {
        if (!evt || this.loader) return;

        this.loader = this.$loading.show();

        // let selectedMovies = this.selectedMovies.map((m) => ({
        //   movie_id: m.movie_id,
        // })) Testing;
        let selectedMovies = this.selectedMovies.map((m) => ({
          movie_id: m.movie_id,
        }));

        let payload = {
          selectedMovies,
        };

        MasterService.insertScheduleMovieSortOrder(payload)
          .then((res) => {})
          .catch((e) => {})
          .finally(() => {
            this.loader.hide();
            this.loader = null;
          });
      },
      checkMoveOnAvailMovieChange: function(evt, originalEvent) {
        if (evt.from.localName != evt.to.localName) {
          // this.$toasted.show('Invalid Drag Option');
          return false; // for cancel drag
        }

        return true;
      },

      getMovieData: function() {
        this.loader = this.$loading.show();
        let payload = {};

        MasterService.getScheduleMovieSortOrder(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.availMovieList = data.availMovieList;
              // this.selectedMovies = data.selectedMovies;
                   this.selectedMovies = data.selectedMovies.filter((x) => {
                return data.scheduledMoviesRaw.find(
                  (y) => x.movie_id == y.movie_id
                );
              });
              this.scheduleMovieRaw = data.scheduledMoviesRaw;
            } else {
              this.$toasted.show("No Movies Found.");
            }
          })
          .catch((e) => {
            this.availMovieList = [];
            this.selectedMovies = [];
            this.scheduleMovieRaw = [];
            console.log({ e });
          })
          .finally(() => {
            setTimeout(() => {
              this.loader.hide();
              this.loader = null;
            }, 100);
          });
      },
    },
  };
</script>

<style scoped>
  .sph-report th,
  td {
    height: 30px;
  }

  .filmwise-report-table > div {
    display: contents;
  }

  .table_header {
    background-color: #c4c5c6;
    color: #3a4759;
    font-weight: 900;
    border-color: #787878;
  }

  .filmwise-report-table td,
  .filmwise-report-table th {
    color: #3a4759;
    border-color: #787878;
  }

  .global_option_wrapper label:not(.custom-control-label) {
    font-size: 11px !important;
  }

  .compulsory_astrick {
    top: -5px;
    right: -4px;
    font-size: 19px;
    position: absolute;
    color: red;
  }

  .checkboxWrapper {
    width: 250px;
    font-size: 13px;
  }

  .global_option_wrapper .multiselect__single {
    font-size: 13px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .global_option_wrapper .multiselect__content-wrapper {
    width: auto;
  }

  .sectionName {
    padding: 5px 0px;
    color: #4a87e1;
  }

  .sectionName .fs-17 {
    /*font-size: 17px !important;*/
  }

  .text-small-instruction {
    font-weight: 400;
  }

  .text-red {
    color: red;
  }

  .disable-field {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .move {
    cursor: move;
  }

  .pointer {
    cursor: pointer;
  }

  .pdf_img {
    width: 150px;
  }

  .pdf_img img {
    width: 100%;
  }

  .payment_bg {
    background-color: #4a87e1;
  }

  .filterButtonToggle {
    min-width: fit-content !important;
    max-width: fit-content !important;
    width: fit-content !important;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .filterSection {
    min-width: 256px;
    border: 1px solid;
    border-radius: 7px;
    border-top-left-radius: 0;
    border-color: var(--blue);
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ScheduleMoviesSortOrder/ScheduleMoviesSortOrder.vue